<template>
  <form
    class="w-full mx-auto rounded-lg px-4 pt-2"
    @submit.prevent="replyTicket()"
  >
    <div class="flex flex-wrap -mx-3 mb-6">
      <div class="w-full md:w-full px-3 mb-2 mt-2">
        <textarea
          class="bg-gray-100 rounded border bg-opacity-75 border-gray-400 leading-normal resize-none w-full h-20 py-2 px-3 font-medium placeholder-gray-700 focus:outline-none focus:bg-white"
          name="body"
          v-model="chat.message"
          placeholder="Type Your reply"
          required
        ></textarea>
      </div>
      <div class="w-full md:w-full md:flex items-start px-3">
        <div class="flex mb-2 items-start md:w-1/2 text-gray-300 px-2 mr-auto">
          <svg
            fill="none"
            class="w-5 h-5 text-gray-200 mr-1"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <p class="text-xs md:text-sm pt-px">Some information here.</p>
        </div>
        <div class="-mr-1">
          <button
            type="submit"
            class="btn w-full text-gray-700 px-4 py-2 font-bold cursor-pointer hover:text-white tracking-wide mr-1"
            :class="{ 'opacity-50 disabled': !isFormFilled }"
            :disabled="!isFormFilled"
          >
            Post Comment
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import firebase from "firebase";
import TicketsService from "@/providers/tickets";
import moment from "moment";

export default {
  name: "ChatReply",
  data() {
    return {
      chat: {
        message: ""
      },
      firebaseUser: {}
    };
  },
  props: ["ticketDetail"],
  computed: {
    isFormFilled() {
      return this.chat.message;
    }
  },
  mounted() {
    this.firebaseUser = firebase.auth().currentUser;
  },
  methods: {
    replyTicket() {
      this.ticketDetail.remarks.push({
        detail: this.chat.message,
        updatedBy: this.firebaseUser.uid,
        updatedOn: moment.utc().format("x")
      });
      TicketsService.saveTicketRemarks(
        this.ticketDetail.id,
        this.ticketDetail.remarks
      )
        .then(() => {
          this.chat.message = ""
          this.$vToastify.success("Comment has been posted successfully");
        })
        .catch(err => {
          this.chat.message = ""
          this.$vToastify.error("Failed to Create ticket");
        });
    }
  }
};
</script>

<style>
@import "../assets/styles/chat.scss";
</style>
